import * as React from 'react';

import { isDefined } from '../..';

export type SummaryInfoProps = {
  label: string;
  primaryValue: React.ReactNode;
  secondaryValue?: React.ReactNode;
};

export const SummaryInfo = ({
  label,
  primaryValue,
  secondaryValue,
}: SummaryInfoProps) => (
  <div className="@SummaryInfo flex flex-col items-end">
    <div className="text-[11px] text-neutral/40 uppercase">{label}</div>
    <div className="text-xl font-semibold">{primaryValue}</div>
    {isDefined(secondaryValue) && (
      <div className="text-sm text-neutral/40">{secondaryValue}</div>
    )}
  </div>
);
